export const UserApi = {
  LoginDetail: '/login/detail',
  SecurityQuestion: 'verify-password/',
  SavePreferences: '/preferences/save'
};

export const ConfigApi = {
  AccountDetails: '/accountdetails',
  GetAccountAdmin: '/settings/admin',
  GetPurchaseOrder: '/purchaseorders',
  GetReferringPhysician: '/referringphysicians?allReferringPhysicians=true',
  GetMobileData: '/mobile/all',
  GetComponents: '/components',
  GetComponentLinkedConfiguration: '/component/linkedConfiguration',
  GetRecurringOrderNames: '/recurring/names',
  GetRecurring: '/recurring',
  GetOrderingPhysicians: '/orderingphysicians',
  GetProducts: '/customercatalog',
  GetProcedures: '/proceduresnames',
  GetProcedure: '/procedure',
  GetRecurringOrder: '/recurring',
  GetNotes: '/notes',
  GetCount: '/alert/count',
  Delete: '/delete',
  DeleteComponent: '/component',
  DismissAlert: '/notes/dismiss',
  DefaultAccount: '/defaultaccount',
  Save: '/save',
  SaveNotes: '/notes/save',
  SaveProcedure: '/procedures/save',
  SpecialProducts: '/specialproducts',
  Suggestion: '/suggestion',
  Mobile: '/mobile',
  Modify: '/modify',
  OrderStub: '/orderstub/reservation',
  OrderStubReservations: '/orderstub/reservations',
  OrderStubRestoreReservations: '/orderstub/restorereservation',
  ReferringPhysician: '/referringphysicians',
  ReferringPhysicianDelete: '/referringphysician/delete',
  ReferringPhysicianSave: '/referringphysicians/save',
  ReturnProduct: '/report/ordersearch?returnOrderFlag=true',
  Report340BReport: '/report/ordersearch?wo340BFlag=true',
  InvoiceSearch: '/invoice/search',
  InvoiceDetail: '/invoice/detail',
  OrderSearch: '/report/ordersearch',
  OrderBy: '/orderedby',
  NDCSearch: '/report/ordersearch?ndcFlag=true',
  PhysicianSearch: '/report/physiciansignoff',
  TimeSlots: '/get/timeslots',
  StaticData: '/data/static',
  details: '/details',
  send: '/send',
  unsentModify: '/unsent/modify',
  linkedCancel: '/linked/cancel',
  linkedDetails: '/linked/details',
  DefaultAccSave: '/defaultaccount/save',
  OktaB2B: '/generate/jwtforoktab2b',
  getLocationHolidayDates: '/pharmacy/holiday'
};

export const OrderApi = {

  SaveNuctracOrder: 'otc/save',
  ExecuteBillingJob: 'otc/monthlybilling',
  SaveBatchOrder: '/schedule/save',
  UnsentOrder: '/unsent',
  SendOrders: '/send',
  Dashboard: '/dashboard',
  GetTimeSlots: '/get/timeslots',
  HoldTimeSlots: '/hold/timeslots',
  ReleaseTimeSlots: '/release/timeslots',
  SaveCart: '/cart/save',
  RejectNotifications: '/reject/notification',
  DismissNotification: '/rejected/dismiss',
  SendOrder: '/send',
  OrderStatus: '/orderstatus',
  SaveInvoiceReturnUrl: '/return',
  AbandonTimeSlots: '/abandoned/timeslots',
  RejectedNotifications: '/reject-notification',
  acknowledgeRejectNotification: '/reject-notification/acknowledge',
  sendEmail340BEntityFormPDF: '/email/send',
  getPatients: '/patient-benefit-eligibility/details',
  getSonexusEnrollmentURL: '/patient-benefit-eligibility/enrollment-url-mappings',
  DeActivatePatient: '/patient-benefit-eligibility/deactivate' 
}

export const ApiPrefix = {
  Auth: '/',
  Login: '',
  User: '',
  nutracConfig: '',
};

export const MiscApi = {
  Settings: '/settings',
  Log: '/log',
  RelayUrl: '/relayurl',
};

export const AuthApi = {

};

export const OktaApi = {
  OktaSession: '/api/v1/sessions/me'
};
